<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
    <ng-container matColumnDef="iban">
      <th mat-header-cell *matHeaderCellDef> Rekeningnummer (IBAN) </th>
      <td mat-cell *matCellDef="let data"> {{data.iban ? data.iban : emptyValuePlaceholder}} </td>
    </ng-container>
  
    <ng-container matColumnDef="consentTime">
      <th mat-header-cell *matHeaderCellDef> Toestemming klant </th>
      <td mat-cell *matCellDef="let data"> {{data.consentTime ? data.consentTime : emptyValuePlaceholder}} </td>
    </ng-container>
  
    <ng-container matColumnDef="revokeConsentTime">
      <th mat-header-cell *matHeaderCellDef> Toestemming ingetrokken </th>
      <td mat-cell *matCellDef="let data"> {{data.revokeConsentTime ? data.revokeConsentTime : emptyValuePlaceholder}} </td>
    </ng-container>
  
    <ng-container matColumnDef="consentText">
      <th mat-header-cell *matHeaderCellDef> Toestemming tekst </th>
      <td mat-cell *matCellDef="let data"> {{data.consentText ? data.consentText : emptyValuePlaceholder}} </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
  
  </table>
  <ng-template #errorTextField>
    <div class="error-text">
      {{errorText}}
    </div>
  </ng-template>
  